import {http} from '../core/http';
import type {checkFileParams, chunkUploadParams, mergeChunksParams, uploadBatchParams, uploadParams} from '../types/upload';

export const uploadService = {
  checkFile(params: checkFileParams) {
    return http.post('/uss/upload_file_by_md5', params);
  },

  checkFileByMd5(params: { file_md5: string }) {
    return http.post('/uss/get_url_by_md5', params);
  },

  getSingleUploadUrl(params: { filename: string }) {
    return http.post('/uss/get_signature', params);
  },

  initMultipart(params: { filename: string }) {
    return http.post('/uss/initiate_multipart', params);
  },

  getPartUploadUrl(params: chunkUploadParams) {
    return http.post('/uss/get_multipart', params);
  },

  completeMultipart(params: mergeChunksParams) {
    return http.post('/uss/complete_multipart', params);
  },

  completeUpload(params: uploadParams) {
    return http.post('/uss/upload_file', params);
  },

  getTempDownloadUrl(params: { obskey: string }) {
    return http.post('/uss/get_download_url', params);
  },

  completeBatchUpload(params: uploadBatchParams) {
    return http.post('/uss/batch_upload_files', params);
  },
};